import { useCallback, useEffect, useState } from "react";
import { useTenantSettingsService } from "../api/tenantSettingsService";
import { TenantSettings } from "../types/tenantSettings";

export type DisplayPreferences = {
  showOwnershipStatus: boolean;
  showOperator: boolean;
  showOwner: boolean;
};

const defaultPreferences: DisplayPreferences = {
  showOwnershipStatus: false,
  showOperator: false,
  showOwner: false,
};

export const useTenantDisplayPreferences = (enabled = true) => {
  const { getTenantSettings } = useTenantSettingsService();
  const [preferences, setPreferences] = useState<DisplayPreferences>(defaultPreferences);
  const [loading, setLoading] = useState(enabled);

  const load = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const data: TenantSettings = await getTenantSettings();
      setPreferences({
        showOwnershipStatus: data.showOwnershipStatus,
        showOperator: data.showOperator,
        showOwner: data.showOwner,
      });
    } catch {
      setPreferences(defaultPreferences);
    } finally {
      setLoading(false);
    }
  }, [enabled, getTenantSettings]);

  useEffect(() => {
    void load();
  }, [load]);

  const showAny =
    preferences.showOwnershipStatus ||
    preferences.showOperator ||
    preferences.showOwner;

  return { preferences, loading, showAny, reload: load };
};
